var _defs, _polygon, _polygon2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew293({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 7.71 15 11.75 15 3.67 8 7.71"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 7.71 1 3.67 1 11.75 8 7.71"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 2.82,
    x2: 8,
    y2: 13.18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew293);
export default __webpack_public_path__ + "static/media/Symbolpack_New_293.1326cd803aa52692967f613d28308683.svg";
export { ForwardRef as ReactComponent };